export function useVersionBanner() {
  const config = useRuntimeConfig()

  const showVersionBanner = config.public.buildVersion?.showVersionBanner ?? false
  const version = config.public.buildVersion?.versionNumber ?? undefined

  return {
    showVersionBanner,
    version
  }
}